import { Box, IconButton } from '@mui/material';
import { CgArrowAlignH } from 'react-icons/cg';

const HandleSashRender = (index: number, active: boolean): React.ReactNode => (
  <Box
    key={index}
    sx={{
      cursor: 'col-resize',
      width: 1,
      height: '100%',
      color: active ? '#00B4D8' : '#F6F6F9',
      position: 'relative',
    }}
  >
    {active && (
      <IconButton
        sx={{
          position: 'absolute',
          top: '40%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
        color="primary"
        aria-label="menu"
      >
        <CgArrowAlignH />
      </IconButton>
    )}
    <Box
      sx={{
        width: '100%',
        height: '100%',
        backgroundColor: active ? '#00B4D8' : '#F6F6F9',
      }}
    >
      <IconButton
        sx={{
          position: 'absolute',
          top: '40%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
        aria-label="menu"
      >
        <CgArrowAlignH />
      </IconButton>
    </Box>
  </Box>
);
export default HandleSashRender;
